import { defineStore } from 'pinia'

export const useSpinnerStore = defineStore('spinner', {
  state: () => ({
    active: false
  }),
  actions: {
    show() {
      this.active = true
    },
    hide() {
      this.active = false
    }
  }
})
